var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewAllSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 2.66675C3.26166 2.66675 2.66699 3.26141 2.66699 4.00008V9.33341H9.33366V2.66675H4.00033ZM10.667 2.66675V9.33341H17.3337V4.00008C17.3337 3.26141 16.739 2.66675 16.0003 2.66675H10.667ZM2.66699 10.6667V16.0001C2.66699 16.7387 3.26166 17.3334 4.00033 17.3334H9.33366V10.6667H2.66699ZM10.667 10.6667V17.3334H16.0003C16.739 17.3334 17.3337 16.7387 17.3337 16.0001V10.6667H10.667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllSvgrepoCom1);
export default __webpack_public_path__ + "static/media/view-all-svgrepo-com 1.338905514085d0633610a07a0a0cb110.svg";
export { ForwardRef as ReactComponent };